export default __webpack_public_path__ + "static/media/pediatric-dentistry.5407a77d.svg";